// extracted by mini-css-extract-plugin
export default {"single-column-layout":"jSnr_"};